import { LegView } from '@mopla/data-models';

import { buildRatableLegs } from './buildRatableLegs';
import { IRatableLeg } from './types';

/** Per-leg rating state carried by the booking itself; no network. */
export const getRatableLegs = (legs: LegView[]): IRatableLeg[] =>
	buildRatableLegs(legs, (leg) => ({ rating: leg.feedback?.rating }));
